import React, { Component } from "react";
import { Table } from "antd";
import moment from "moment";

class CardFile extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleDelete = uuid => {
    this.props.handleChooseFile(
      this.props.dataSource.filter(item => item.uuid !== uuid)
    );
  };

 columns = () => {
    const columns = [
      {
        title: "合同编号",
        dataIndex: "no",
        render: (text, record) => (
          <a onClick={() => this.props.changePage(record.uuid)}>{record.no}</a>
        ),
      },
      {
        title: "合同周期",
        dataIndex: "beginDate",
        render: (text, record) =>
          record.beginDate && record.endDate ? (
            <span>
              {moment.unix(record.beginDate / 1000).format("YYYY-MM-DD")}至
              {moment.unix(record.endDate / 1000).format("YYYY-MM-DD")}
            </span>
          ) : null,
      },
    ];
    return columns;
  }

  render() {
    const { dataSource } = this.props;
    return (
      <Table
        columns={this.columns()}
        dataSource={dataSource}
        pagination={false}
        rowKey="uuid"
        onChange={this.handleTableChange}
      />
    );
  }
}

export default CardFile;



// WEBPACK FOOTER //
// ./src/components/incubator/contract/comm/TableRenew.js